module.exports = __webpack_public_path__ + "static/media/undraw_Business_plan_re_0v81.4ff0cc62.svg";